import api from './api'

export const therapyCategoryService = {
  fetchList() {
    return api.get('/therapy/categories')
  },
  create(payload) {
    return api.post('/therapy/categories', payload)
  },
  update(id, payload) {
    return api.put(`/therapy/categories/${id}`, payload)
  },
  updateStatus(id, status) {
    return api.patch(`/therapy/categories/${id}/status`, null, { params: { status } })
  }
}